import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FOCUS_RING } from './focusRing.ts'
import { icons } from './icons.ts'
import { Tooltip } from './Tooltip.tsx'

/**
 * The finding's sentence, on an icon at the head of the row.
 *
 * It used to appear only on the amber rows, and only in the pin's own slot --
 * so a divergence, which is the row somebody most needs explained, had no
 * explanation at all beyond the prose line under the title, and an undecided
 * row traded away its pin to show one.
 *
 * Now every finding that has something to say carries it, in the receita
 * column ahead of the value, and the pin stays where it is. The colour is the
 * disposition's: a reader should be able to tell a difference from a gap
 * without reading a word, which is the same claim the row's fill makes.
 */
export function ReasonIcon({ reason, disposition }: { reason: string; disposition: string }) {
  const tone =
    disposition === 'divergence'
      ? 'text-icon-error'
      : disposition === 'undecided'
        ? 'text-icon-warning'
        : 'text-icon-weak'

  return (
    <Tooltip text={reason}>
      {/*
        `button`, not `span`: the sentence is the one part of a finding that is
        not written on the screen, so somebody navigating by keyboard has to be
        able to reach it. Out of the tab order all the same: a conferência is
        walked by its apontamentos, and a stop on every row would put dozens
        of them between a pharmacist and the next answer.
      */}
      <button
        type="button"
        tabIndex={-1}
        aria-label={reason}
        className={`flex items-center ${FOCUS_RING}`}
        onClick={(event) => event.stopPropagation()}
      >
        <FontAwesomeIcon icon={icons.info} className={`${tone} text-xs`} aria-hidden="true" />
      </button>
    </Tooltip>
  )
}
